import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewArticle from 'Views/view-article';
import OneQuickShopv2 from 'Modules/module-oneQuickShopv2';

"use strict";

// Global requires
whenDomReady(function(){
    console.log('init article');
    new ViewArticle({el: $('#MainContent')});

    if ( $('.collection-products').length) {
        OneQuickShopv2.init({});
    }
});